import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {intlShape, FormattedMessage, injectIntl, FormattedHTMLMessage} from 'react-intl';
import {FIXED_APR} from '../../config/DEConstants';
import {connect} from 'react-redux';
import _ from 'lodash';
import './InstallmentSummary.less';
import Tooltip from '../../../shared-components/ToolTip/ToolTip';
import GriffinNumber from 'griffin-paypal/lib/client/number';

const LOCALE_PREFIX = 'DE/pages/RepaymentPage/RepaymentPage';

export class InstallmentSummary extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        purchaseAmount: PropTypes.string.isRequired,
        currencySymbol: PropTypes.string.isRequired,
        apr: PropTypes.string.isRequired,
        fixedInterestRate: PropTypes.string.isRequired,
        totalDue: PropTypes.string.isRequired,
        term: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        interval: PropTypes.string.isRequired,
        installmentPayment: PropTypes.string.isRequired,
        totalInterest: PropTypes.string.isRequired,
        localityMetadata: PropTypes.object
    };

    render() {
        const {
            purchaseAmount, apr, fixedInterestRate,
            totalDue, term, interval, intl,
            installmentPayment, currencySymbol, totalInterest,
            localityMetadata
        } = this.props;

        const griffinNumberHandler = GriffinNumber.createHandler(localityMetadata);
        const aprNumberOptions = {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        };

        return (
            <div className="installmentSummaryBox">
                <div className="installmentSummaryTopBox">
                    <p className="vx_text-body-md_medium installmentSummaryContent-term">
                        <FormattedHTMLMessage
                            id={+apr === +FIXED_APR ? 
                                `${LOCALE_PREFIX}.installmentSummary.installmentTermZeroApr` :
                                `${LOCALE_PREFIX}.installmentSummary.installmentTerm`}
                            values={{term, installmentPayment}}
                        />
                    </p>

                    <div className="installmentSummaryContent-value">
                        <div className="vx_text-body-md">
                            <div className="installmentSummaryContent-eMoney">
                                <FormattedMessage id={`${LOCALE_PREFIX}.installmentSummary.purchaseAmount`} />
                                <Tooltip
                                    id="financialInfo"
                                    text={intl.formatMessage({ id: `${LOCALE_PREFIX}.installmentSummary.eMoney` })}
                                />
                            </div>
                            <span className="">{purchaseAmount}</span>
                        </div>
                        <div className="vx_text-body-md">
                            <FormattedMessage id={`${LOCALE_PREFIX}.installmentSummary.totalInterest`} />
                            <span className="">{totalInterest}</span>
                        </div>
                        <hr className="vx_hr-alt" />
                        <div className="vx_text-body-md">
                            <FormattedMessage id={`${LOCALE_PREFIX}.installmentSummary.totalDue`} />
                            <span className="totalDue">{totalDue}</span>
                        </div>
                    </div>

                    <p className="installmentSummaryContent-lenderText">
                        <FormattedMessage id={`${LOCALE_PREFIX}.installmentSummary.lenderText`} />
                    </p>
                </div>
                {+apr === +FIXED_APR ? null : <div className="installmentSummaryBottomBox">
                    <div className="vx_text-body-md installmentSummaryBottomBox-apr">
                        <FormattedMessage id={`${LOCALE_PREFIX}.installmentSummary.apr`} />
                        <span>&nbsp;{griffinNumberHandler.formatNumber(apr, aprNumberOptions)}%</span>
                    </div>
                    <div className="vx_text-body-md installmentSummaryBottomBox-fixedInterest">
                        <FormattedMessage id={`${LOCALE_PREFIX}.installmentSummary.fixedInterestRate`} />
                        <span>&nbsp;{griffinNumberHandler.formatNumber(fixedInterestRate, aprNumberOptions)}%</span>
                    </div>
                </div>}
            </div>

        );
    }
}

export const mapStateToProps = state => ({
    purchaseAmount: _.get(state, 'serverData.cart.gross_total_amount.format'),
    currencySymbol: _.get(state, 'serverData.currencySymbol'),
    apr: _.get(state, 'serverData.financingDetails.apr', ''),
    fixedInterestRate: _.get(state, 'serverData.financingDetails.nominal_rate', ''),
    totalDue: _.get(state, 'serverData.financingDetails.total_cost', ''),
    term: _.get(state, 'serverData.financingDetails.term', ''),
    interval: _.get(state, 'serverData.financingDetails.interval', ''),
    installmentPayment: _.get(state, 'serverData.financingDetails.monthly_payment', ''),
    totalInterest: _.get(state, 'serverData.financingDetails.total_interest', ''),
    localityMetadata: _.get(state, 'serverData.localityMetadata', {})
});

export default connect(mapStateToProps)(injectIntl(InstallmentSummary));
